module.exports = __webpack_public_path__ + "img/waistband elastic length.721120ca.png";